import {registerCrudStore} from '@/libs/core/crud/register-crud-store';
import {WalletModel} from '@/libs/Api';
import {WalletsDataService} from '@/libs/wallets/wallets-data-service';
import {StoreName} from '@/libs/core/store/store-name';

export const walletsStore = registerCrudStore<WalletModel, WalletModel>(StoreName.Wallet, new WalletsDataService());
